import pigeon from "../../../utilities/js/pigeon/pigeon";

const mutations = {
  updateProduct(state, updatedData) {
    if (!updatedData) {
      return;
    }
    state.productData = updatedData;
    pigeon.publish("salebox:setcounter", updatedData.productDetails.product.selectedQuantity);
    pigeon.publish("productGallery:resetSwiper");
    this.currentGalleryIndex = 0;
  },
  initPhotoSwipe(state, imagesData) {
    state.productData.currentGalleryIndex = imagesData.showImage;
    state.productData.initPhotoSwipe = true;
  },
  indexUpdate(state, index) {
    state.productData.currentGalleryIndex = index;
  },
  updatePrice(state, updatedPrice) {
    state.productData.priceAvailability = updatedPrice;
  },
  updateQuantity(state, newQuantity) {
    state.productData.productDetails.product.selectedQuantity = parseInt(newQuantity);
    pigeon.publish("salebox:setcounter", newQuantity);
  },
};

export default mutations;
